<template>
  <div>
    <form class="form-group">
      <div class="form-row mt-2">
        <label for="email">Email</label>
        <input id="email" class="form-control" type="text" v-model="editedSubscription.email"/>
      </div>
      <div class="form-row mt-2">
        <label for="fromDate">Von</label>
        <input id="fromDate" class="form-control" type="date" v-model="editedSubscription.fromDate"/>
      </div>
      <div class="form-row mt-2">
        <label for="toDate">Bis</label>
        <input id="toDate" class="form-control" type="date" v-model="editedSubscription.toDate"/>
      </div>
      <div class="form-row mt-3">Wochentage</div>
      <div class="form-row mb-3">
        <div class="form-check mr-3" v-for="day in ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']"
             :key="'day_' + day">
          <input v-model="editedSubscription[day]"
                 class="form-check-input"
                 type="checkbox"
                 :id="'weekday_check_' + day"
                 :checked="editedSubscription[day]">
          <label class="form-check-label mr-3" :for="'weekday_check_' + day">
            {{ day }}
          </label>
        </div>
      </div>
      <div class="form-row mt-2">
        <label for="duration">Mindestlänge</label>
        <input id="duration" class="form-control" type="number" v-model="editedSubscription.minDuration"/><br/>
      </div>
      <div class="form-row mt-2">
        <div class="form-check">
          <input id="trip" class="form-check-input" type="checkbox"
                 v-model="editedSubscription.trip"/>
          <label for="trip">nur Fahrt</label>
        </div>
      </div>
    </form>
    <div class="mt-3 text-right">
      <button :disabled="!formValid" class="btn btn-success"
              @click="$emit('input', editedSubscription)">Speichern
      </button>
    </div>
  </div>
</template>

<script>
const emptySubscription = {
  fromDate: null,
  toDate: null,
  email: null,
  minDuration: 3,
  trip: false,
  mon: true,
  tue: true,
  wed: true,
  thu: true,
  fri: true,
  sat: true,
  sun: true
}

export default {
  props: {
    value: Object
  },
  data() {
    return {
      editedSubscription: {...emptySubscription},
      weekdays: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
    }
  },
  computed: {
    formValid() {
      return this.editedSubscription.fromDate
          && this.editedSubscription.toDate
          && this.editedSubscription.toDate >= this.editedSubscription.fromDate
          && this.editedSubscription.minDuration >= 3
          && this.editedSubscription.minDuration <= 5
          && this.editedSubscription.email
    },
  },
  methods: {
    reset() {
      this.editedSubscription = emptySubscription;
    }
  },
  watch: {
    value: {
      handler: function (newVal) {
        if (!newVal)
          this.editedSubscription = {...emptySubscription}
        else
          this.editedSubscription = this.value
      },
      immediate: true
    }
  }
}
</script>
